import React from 'react';
import { IconButton, InputAdornment } from '@mui/material';
import IconEyeClosed from 'shared/icons/eyeClosed';
import IconEyeOpen from 'shared/icons/eyeOpen';

export function HideTextInputAdornment({
  position,
  onClick,
  isVisible,
}: {
  position: 'start' | 'end';
  onClick: () => void;
  isVisible: boolean;
}) {
  return (
    <InputAdornment position={position}>
      <IconButton onClick={onClick}>
        {isVisible ? <IconEyeOpen /> : <IconEyeClosed />}
      </IconButton>
    </InputAdornment>
  );
}
